import { Box, Stack, TextField } from "@mui/material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AutoCompleteList from "components/AutoCompleteList";
import moment from "moment";
import StockHistoryTable from "pages/inventory/history_template/StockHistoryTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { dispatch } from "store";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";

import { getLocationStockHistoryThunk } from "store/reducers/inventory/stock/locationStockSlice";

const LocationStockHistory = () => {
  const [searchParams] = useSearchParams();
  const time = searchParams.get("time");
  const location = searchParams.get("location");
  const [filter, setFilter] = useState({
    time: time ? moment(time).add(1, "second") : moment(),
    location: null,
  });

  useEffect(() => {
    dispatch(
      getLocationStockHistoryThunk({
        time: filter.time?.toISOString(),
        location: filter.location?.id ?? "",
      })
    );
  }, [filter.location, filter.time]);
  const state = useSelector((state) => state.locationStock);

  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);

  useEffect(() => {
    if (location && locations) {
      const dist = locations.find((item) => item.id === parseInt(location));
      //   console.log(dist)
      if (dist) {
        setFilter((state) => ({ ...state, location: dist }));
      }
    }
  }, [location, locations]);
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5} marginY={2}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="Pick a date"
            value={filter.time}
            onChange={(value) => setFilter({ ...filter, time: value })}
            renderInput={(params) => (
              <TextField variant="outlined" fullWidth {...params} />
            )}
          />
        </LocalizationProvider>

        <AutoCompleteList
          items={locations}
          name="name"
          label="Filter kitchen"
          setValue={(value) => ({ ...filter, location: filter.location })}
          value={filter.location}
        />
      </Stack>
      <StockHistoryTable items={state.history} />
    </Box>
  );
};

export default LocationStockHistory;
